// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ad16ecad","125":"c92353e8","833":"dc3a3f6d"}[chunkId] + ".chunk.js";
};